export default "__VITE_ASSET__CW$ZYFk3__"